import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { copyTextToClipboard } from 'helpers/general-helpers'
import { CopyToClipboardIcon } from '../icons'
import { Tooltip } from 'components/tooltip'
import { AdjustableComponent, useClasses } from '../../utils/hooks/useClasses'

type CopyToClipboardProps = {
  stringToCopy: string
}

type CopyToClipboardStyles = {
  span?: string
  icon?: string
}

export const CopyToClipboard: AdjustableComponent<CopyToClipboardProps, CopyToClipboardStyles> = ({
  stringToCopy,
  classes,
}) => {
  const { t } = useTranslation()
  const [copied, setCopied] = React.useState(false)

  const styles = useClasses(
    {
      span: null,
      icon: null,
    },
    classes,
  )

  return (
    <Tooltip
      placement="top"
      onVisibleChange={visible => {
        if (!visible) {
          setCopied(false)
        }
      }}
      overlay={<span>{copied ? t('tooltip.copied') : t('tooltip.copyToClipboard')}</span>}
    >
      <span className={styles.span}>
        <CopyToClipboardIcon
          className={styles.icon}
          onClick={() => {
            copyTextToClipboard(stringToCopy)
            setCopied(true)
          }}
        />
      </span>
    </Tooltip>
  )
}
